import * as t from './actionTypes';

const initialState = {};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case t.SET_USER_AGENT:
      return {
        ...state,
        userAgent: action.userAgent,
      };
    case t.SET_RECAPTCHA_SITE_KEY:
      return {
        ...state,
        siteKey: action.siteKey,
      };
    case t.SET_RELEASE:
      return {
        ...state,
        release: action.release,
      };
    case t.SET_ROUTE_NAME:
      return {
        ...state,
        routeName: action.routeName,
      };
    case t.SET_INTERVAL_ID:
      return {
        ...state,
        pollingIntervalId: action.pollingIntervalId,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./modules/App/redux/reducer.js